// src/components/Sections/CoverageSection/CoverageSection.jsx

import React from 'react';
import './CoverageSection.scss';

import courseScreenshot from '../../../assets/images/marketing/ttg-course-network-phone.png';

const regions = [
  'Halton',
  'Peel',
  'Toronto',
  'York',
  'Durham'
];

export default function CoverageSection() {
  return (
    <section
      id="network"
      className="network-v4 section-v2 section-v2--soft"
    >
      <div className="container network-v4__layout">
        <div className="network-v4__copy">
          <p className="eyebrow">The Tour Network</p>

          <h2>
            Public golf is your home course.
          </h2>

          <p>
            Explore mapped public courses across the founding region.
            The directory helps you choose where to play; your membership
            travels with you. Participating Series stops and course
            partnerships will be identified as they are confirmed.
          </p>

          <div className="network-v4__total">
            <strong>90+</strong>
            <span>mapped public courses · directory listings, not claimed partners</span>
          </div>

          <div className="network-v4__regions">
            {regions.map((region) => (
              <span key={region}>{region}</span>
            ))}
          </div>
        </div>

        <div className="network-v4__visual">
          <span className="network-v4__ghost" aria-hidden="true">
            PLAY HERE
          </span>

          <svg
            className="network-v4__route"
            viewBox="0 0 640 500"
            aria-hidden="true"
          >
            <path d="M76 372 C 154 310, 211 349, 264 302 S 364 246, 420 214 S 509 132, 585 88" />
            <path d="M264 302 C 289 355, 332 390, 384 416" />
            <circle cx="76" cy="372" r="8" />
            <circle cx="264" cy="302" r="8" />
            <circle cx="420" cy="214" r="10" />
            <circle cx="585" cy="88" r="8" />
            <circle cx="384" cy="416" r="8" />
          </svg>

          <figure className="network-v4__phone">
            <img
              src={courseScreenshot}
              alt="The Tour Golfers course discovery and Tour Series courses"
              loading="lazy"
            />
          </figure>

          <div className="network-v4__pin network-v4__pin--one">
            Deerfield
          </div>

          <div className="network-v4__pin network-v4__pin--two">
            BraeBen
          </div>

          <div className="network-v4__pin network-v4__pin--three">
            Crosswinds
          </div>
        </div>
      </div>
    </section>
  );
}
